import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar.tsx';
import { useAuth } from '../context/AuthContext.tsx';

const API_BASE = process.env.REACT_APP_API_URL + '/api';


const NieuweRonde: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({
    zichtbaar: true,
    type: '',
    naam: '',
    beschrijving: ''
  });

  useEffect(() => {
    document.title = 'Nieuwe Ronde - Thuisverpleging Portaal';
  }, []);

  const handleInputChange = (field: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
  try {
    const token = localStorage.getItem("auth_token");
    if (!token) return alert("U moet ingelogd zijn!");

        const response = await fetch(`${API_BASE}/tours`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            naam: formData.naam,
            type: formData.type,
            short: "",
            description: formData.beschrijving,
            visible: formData.zichtbaar
          })
        });


    const data = await response.json();

    if (!response.ok) {
      return alert(data.message || "Fout bij aanmaken ronde");
    }

    alert(`Ronde "${formData.naam}" succesvol aangemaakt!`);
    navigate(`/rondes/${data.id}`); // ➜ Ga direct naar detail om verpleegkundigen te koppelen

  } catch (error) {
    console.error("Create ronde error:", error);
    alert("Kon ronde niet aanmaken");
  }
};


  const handleBack = () => {
    navigate('/rondes');
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar open={true} onClose={() => {}} />
      
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Container maxWidth="md">
          {/* Header with back button */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <IconButton 
              onClick={handleBack}
              sx={{ 
                mr: 2, 
                color: '#4aa8b4',
                '&:hover': { backgroundColor: '#e3f2fd' }
              }}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" sx={{ color: '#666' }}>
              Terug
            </Typography>
          </Box>

          {/* Form Paper */}
          <Paper sx={{ p: 4, boxShadow: 2 }}>
            {/* Zichtbaar Checkbox */}
            <Box sx={{ mb: 3 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.zichtbaar}
                    onChange={(e) => handleInputChange('zichtbaar', e.target.checked)}
                    sx={{ 
                      color: '#4aa8b4',
                      '&.Mui-checked': { color: '#4aa8b4' }
                    }}
                  />
                }
                label="Zichtbaar"
              />
            </Box>

            {/* Type Dropdown */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, color: '#666' }}>
                Type
              </Typography>
              <FormControl fullWidth>
                <InputLabel>Select...</InputLabel>
                <Select
                  value={formData.type}
                  onChange={(e) => handleInputChange('type', e.target.value)}
                  label="Select..."
                >
                  <MenuItem value="vroege">Vroege</MenuItem>
                  <MenuItem value="late">Late</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Naam Field */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, color: '#666' }}>
                Naam
              </Typography>
              <TextField
                fullWidth
                placeholder="naam"
                value={formData.naam}
                onChange={(e) => handleInputChange('naam', e.target.value)}
                variant="outlined"
              />
            </Box>

            {/* Beschrijving Field */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, color: '#666' }}>
                Beschrijving
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="beschrijving (optioneel)"
                value={formData.beschrijving}
                onChange={(e) => handleInputChange('beschrijving', e.target.value)}
                variant="outlined"
              />
            </Box>

            {/* Submit Button */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={!formData.naam.trim()}
                sx={{
                  backgroundColor: '#4aa8b4',
                  '&:hover': { backgroundColor: '#3a9ca8' },
                  '&:disabled': { backgroundColor: '#ccc' },
                  textTransform: 'none',
                  px: 3,
                  py: 1
                }}
              >
                Aanmaken
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default NieuweRonde;